export default function SerpCommon() {
  const SELECTOR_MAIN_ELEMENT = 'main';

  let pageId;
  let pageType;
  let pageCurrency;

  this.getPageId = () => {
    if (!pageId) {
      pageId = $(SELECTOR_MAIN_ELEMENT).attr('data-page');
    }

    return pageId;
  };

  this.getPageType = () => {
    if (!pageType) {
      pageType = $(SELECTOR_MAIN_ELEMENT).attr('data-type');
    }

    return pageType;
  };

  this.getPageCurrency = () => {
    if (!pageCurrency) {
      pageCurrency = $(SELECTOR_MAIN_ELEMENT).attr('data-curr');
    }

    return pageCurrency;
  };

  this.getUrlParam = (name) => {
    const results = new RegExp(`[?&]${name}=([^&#]*)`)
      .exec(window.location.search);

    return (results !== null) ? results[1] || 0 : null;
  };
}
